import React, { useState } from 'react';

import { useSnackbar } from 'notistack';

import { Box, MenuItem, Stack, TextField } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import { Button } from '~/components/Experiences/components';

import { PROVIDER_OPTIONS } from '~/consts/experiences';

import * as experienceService from '~/services/ExperiencesService';

export default function SyncOffers() {
  const [selectProvider, setSelectedProvider] = useState<Experiences.ProviderKey>();
  const [providerIdsText, setProviderIdsText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();

  const handleFilterChange = (event) => {
    setSelectedProvider(event.target.value);
  };

  const handleProviderIdsChange = (event) => {
    const value = event.target.value;
    setProviderIdsText(value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    experienceService
      .syncOneOffer({
        providerIds: providerIdsText.split(',').map((id) => id.trim()),
        providerKey: selectProvider,
      })
      .then(() => {
        enqueueSnackbar('Sync offers scheduled successfully', { variant: 'success' });
        setProviderIdsText('');
      })
      .catch(() => {
        enqueueSnackbar('Error scheduling sync offers', { variant: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box component={'form'} onSubmit={onSubmit}>
      <Stack direction="row" spacing={2}>
        <TextField
          sx={{ minWidth: 200 }}
          select
          required
          label="Provider"
          variant="outlined"
          placeholder="Select a provider"
          onChange={handleFilterChange}
        >
          {PROVIDER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          required
          fullWidth
          label="Provider deal ID's"
          variant="outlined"
          value={providerIdsText}
          placeholder={`Enter provider deal ID's ${
            selectProvider ? `without "${selectProvider}:"` : ''
          } separated by commas`}
          onChange={handleProviderIdsChange}
        />
        <Button type="submit" variant="contained" loading={loading}>
          Sync
        </Button>
      </Stack>
    </Box>
  );
}
